export default "__VITE_ASSET__DJEpd9AD__"